import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, Heart, Users, MapPin, Shield } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { motion } from 'framer-motion';

export default function AboutPage() {
  const values = [
    {
      icon: Heart,
      title: 'Paixão pelos Animais',
      description: 'Nascemos do amor pelos animais e da vontade de lhes proporcionar o melhor cuidado possível.'
    },
    {
      icon: Users,
      title: 'Comunidade',
      description: 'Criamos uma comunidade de confiança entre donos de animais e prestadores dedicados.'
    },
    {
      icon: MapPin,
      title: 'Proximidade',
      description: 'Conectamos pessoas da mesma cidade, facilitando encontros pessoais e criando laços de confiança.'
    },
    {
      icon: Shield,
      title: 'Segurança',
      description: 'Promovemos a verificação de perfis e avaliações reais para maior tranquilidade.'
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="container mx-auto px-4 py-8 max-w-4xl">
        <Link to="/">
          <Button variant="ghost" className="mb-6">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar
          </Button>
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1 className="text-3xl font-bold font-outfit mb-4">Sobre Nós</h1>
          <p className="text-lg text-muted-foreground mb-12">
            A história por detrás do PasseioPerfeito
          </p>

          {/* Mission */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold mb-4">A Nossa Missão</h2>
            <div className="bg-primary/5 rounded-2xl p-6 border border-primary/10">
              <p className="text-lg leading-relaxed">
                Conectar donos de cães e gatos com <strong>pet sitters de confiança</strong> em cada cidade de Portugal. 
                Acreditamos que todos os animais merecem o melhor cuidado, mesmo quando os seus donos não podem estar presentes.
              </p>
            </div>
          </section>

          {/* Story */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold mb-4">A Nossa História</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              O PasseioPerfeito nasceu de uma necessidade real: encontrar alguém de confiança para cuidar 
              dos nossos amigos de quatro patas quando não podemos estar com eles.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Cansados de depender de favores de amigos ou deixar os animais sozinhos, decidimos criar 
              uma plataforma que tornasse fácil encontrar prestadores verificados e avaliados por outros 
              donos de animais.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              Hoje, orgulhamo-nos de ter ajudado milhares de famílias portuguesas a encontrar o 
              cuidador perfeito para os seus pets, desde passeios diários até hospedagens de longa duração.
            </p>
          </section>

          {/* Values */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold mb-6">Os Nossos Valores</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {values.map((value) => {
                const Icon = value.icon;
                return (
                  <Card key={value.title}>
                    <CardContent className="p-6">
                      <div className="flex items-start gap-4">
                        <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                          <Icon weight="duotone" className="w-6 h-6 text-primary" />
                        </div>
                        <div>
                          <h3 className="font-semibold mb-1">{value.title}</h3>
                          <p className="text-sm text-muted-foreground">{value.description}</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </section>

          {/* CTA */}
          <section className="bg-primary text-primary-foreground rounded-2xl p-8 text-center">
            <h2 className="text-2xl font-semibold mb-4">Junte-se à Nossa Comunidade</h2>
            <p className="mb-6 opacity-90">
              Sejá como cliente ou prestador, faça parte da maior comunidade de amantes de animais em Portugal.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/login">
                <Button variant="secondary" className="rounded-full">
                  Criar Conta Grátis
                </Button>
              </Link>
              <Link to="/como-funciona">
                <Button variant="outline" className="rounded-full border-white/30 text-white hover:bg-white/10">
                  Saber Mais
                </Button>
              </Link>
            </div>
          </section>
        </motion.div>
      </main>

      <Footer />
    </div>
  );
}
